/* global moment */

const activeTz = process.env.VUE_APP_TIME_ZONE || 'America/Phoenix'

// TODO - Keep until all old references are migrated !!!
const format = (dateTime, pattern) => moment(dateTime).tz(activeTz).format(pattern)

const dateFormat = (dateTime, pattern) => {
  return moment(dateTime).tz(activeTz).format(pattern)
}

export default {
  format,
  dateFormat
}
